// Транспорт точек и устройств. Пути относительны env.apiBaseUrl, который уже
// содержит `/api/v1` — повтор версии здесь давал бы 404 на каждом запросе.

import { httpClient } from '@/shared/api';
import type { components } from '@/shared/api/generated/schema';

const LOCATIONS = '/locations';
const DEVICES = '/locations/devices';
const KIOSK_BINDINGS = '/locations/kiosk-bindings';

// Типы приезжают из СГЕНЕРИРОВАННОЙ схемы, а не пишутся руками: рукописная копия
// расходится с сервером молча, и расхождение всплывает не при сборке, а пустым полем
// на экране. Конвейер `pnpm api:sync` для того и существует.
export type Location = components['schemas']['Location'];
export type Device = components['schemas']['Device'];
export type KioskBindingRecord = components['schemas']['KioskBinding'];
export type KioskBindingCreated = components['schemas']['KioskBindingCreated'];
export type LocationCreated = components['schemas']['LocationCreated'];

export type Paginated<T> = {
  readonly count: number;
  readonly results: readonly T[];
};

export type LocationPayload = {
  readonly name: string;
  readonly address?: string;
  readonly timezone?: string;
  readonly notes?: string;
  readonly clone_catalog?: boolean;
  /** Списание разом на табло (T-052) — пишет только админ сети. */
  readonly bulk_dispose_expired?: boolean;
  readonly bulk_dispose_all?: boolean;
  /** Печать на утро (T-055): разрешение и время утра «ЧЧ:ММ» в зоне точки. */
  readonly preprint_enabled?: boolean;
  readonly preprint_time?: string | null;
};

export const locationsApi = {
  list: () => httpClient.get<Paginated<Location>>(`${LOCATIONS}/`),

  create: (body: LocationPayload) => httpClient.post<LocationCreated>(`${LOCATIONS}/`, body),

  update: (id: string, body: Partial<LocationPayload>) =>
    httpClient.patch<Location>(`${LOCATIONS}/${id}/`, body),

  devices: () => httpClient.get<Paginated<Device>>(`${DEVICES}/`),

  createDevice: (body: { location: string; name: string }) =>
    httpClient.post<Device>(`${DEVICES}/`, body),

  /** Перевыдача кода. Штатная операция: код живёт минуты. */

  /** Закреплённые планшеты видимых точек (T-040). Ключей в списке нет. */
  kioskBindings: (location?: string) =>
    httpClient.get<Paginated<KioskBindingRecord>>(
      `${KIOSK_BINDINGS}/`,
      location ? { searchParams: { location } } : undefined,
    ),

  /** Закрепить планшет. Ключ `kiosk_token` приходит в ответе ЕДИНСТВЕННЫЙ раз. */
  bindKiosk: (body: { location: string; name: string }) =>
    httpClient.post<KioskBindingCreated>(`${KIOSK_BINDINGS}/`, body),

  /** Открепить: гасит и сессии, открытые на планшете по PIN. */
  revokeKiosk: (id: string) =>
    httpClient.post<KioskBindingRecord>(`${KIOSK_BINDINGS}/${id}/revoke/`),
} as const;
